<template>
  <div class='app_container'>
    <div class="app_shell">
      <div class="top_header">
        <a class="header_logo_link" href='https://www.contentos.io'>
          <img class='header_logo' src='../../assets/img/Contentos_logo.svg' alt='Contentos'>
        </a>
        <div class="language_bg">
          <el-dropdown>
            <div>{{curLanguage}}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in languageList" :key='index' @click.native="changeLanguage(item.languageType)" >
                {{item.language}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="language-arrow-down"></div>
        </div>
      </div>
      <div class='desc_container'>
        <div v-if="checkIsGetTokenListStage()" class="desc_title">{{ $t('message.panel_title_step1') }}</div>
        <div class="desc_text">{{ $t('message.service_desc') }}</div>
      </div>

      <div v-if="serviceAvailable" :class="['operate_container', getStagePanelClass()]">
        <div v-if="checkIsGetDepositInfoStage()" class="panel_header">
          <div class="panel_title">{{ getPanelTitle() }}</div>
          <div v-if="getPanelSubtitle()" class="panel_subtitle">{{ getPanelSubtitle() }}</div>
        </div>

        <template v-if='checkIsGetTokenListStage()'>
          <tokenListView :ref=tokenListViewRef :token-list='tokenList'></tokenListView>
        </template>
        <template v-else-if='checkIsGetDepositInfoStage()'>
          <depositInfoView :ref=depositInfoViewRef :deposit-info='depositInfo'></depositInfoView>
        </template>
        <div v-if="checkIsGetTokenListStage()" class="action_row">
          <button v-if="tokenList.length" class="next_btn" @click='onclickNextBtn()'>{{getNextBtnTitle()}}</button>
          <button class="secondary_btn status_entry_btn" @click="goToStatusPage"><span>{{$t('message.view_status')}}</span></button>
        </div>
        <div v-else-if="checkIsGetDepositInfoStage()" class="action_row">
          <button class="secondary_btn" @click="backToStep1"><span>{{$t('message.prev_step')}}</span></button>
          <button class="secondary_btn status_entry_btn" @click="goToStatusPage"><span>{{$t('message.view_status')}}</span></button>
        </div>
        <loadingView v-show="isShowLoading"></loadingView>
      </div>

      <div v-else class="out_of_service">
        <el-alert
          title="Service temporarily unavailable"
          description="An unsuccessful token swap was detected in the past 20 minutes. We will resume the service as soon as the problem is resolved. We appreciate your understanding. YOUR FUND IS SAFE."
          type="warning"
          effect="dark"
          :closable="false"
          show-icon>
        </el-alert>
      </div>

      <el-footer>
        <a class="service_mail" href='mailto:service@contentos.io'>service@contentos.io</a>
        <span class="footer_copyright">© 2018 - {{ currentYear }} COS FOUNDATION</span>
      </el-footer>
    </div>
  </div>
</template>

<script>
import utils from '../../common/v2/utils'
import tokenListView from '../../components/v2/tokenListView'
import depositInfoView from '../../components/v2/depositInfoView'
import webAPI from '../../common/v2/webService'
import loadingView from '../../components/v2/loading'
import i18n from '../../i18n/i18n'

export default {
  name: 'homeV2',
  components: {
    tokenListView,
    depositInfoView,
    loadingView
  },
  data () {
    return {
      tokenList: [],
      curStage: utils.SwapStage.SwapStageGetTokenList,
      curSwapType: utils.SwapType.SwapTypeErc20ToBep2,
      swapAddress: '',
      exChangeMemo: '',
      tokenListViewRef: 'tokenListView',
      depositInfoViewRef: 'depositInfoView',
      depositInfo: {},
      isQuerying: false,
      isShowLoading: false,
      languageList: this.getLanguageList(),
      curLanguageType: utils.languageType.languageTypeEn,
      curLanguage: 'English',
      serviceAvailable: true,
      currentYear: new Date().getFullYear()
    }
  },
  methods: {
    getCurrentLanguageType () {
      let local = i18n.locale
      if (utils.checkIsSupportLanguage(local)) {
        return i18n.locale
      } else {
        this.$i18n.locale = utils.languageType.languageTypeEn
        console.log('not support language type:', local)
      }

      return utils.languageType.languageTypeEn
    },

    getCurrentLanguage () {
      console.log('curLanguageType is', this.curLanguageType)
      for (let info of this.languageList) {
        if (this.curLanguageType === info.languageType) {
          return info.language
        }
      }
      return 'English'
    },

    changeLanguage (val) {
      if (this.curLanguageType !== val) {
        for (let info of this.languageList) {
          if (info.languageType === val) {
            this.curLanguage = info.language
            this.curLanguageType = val
            this.$i18n.locale = val
            sessionStorage.setItem('locale', val)
          }
        }
      }
    },

    getLanguageList () {
      return [{ languageType: utils.languageType.languageTypeTW, language: '繁體中文' },
        { languageType: utils.languageType.languageTypeCN, language: '简体中文' },
        { languageType: utils.languageType.languageTypeEn, language: 'English' },
        { languageType: utils.languageType.languageTypeKo, language: '한국어' },
        { languageType: utils.languageType.languageTypeVietnam, language: 'Tiếng việt' },
        { languageType: utils.languageType.languageTypeRussian, language: 'Русский' }]
    },

    checkIsGetTokenListStage () {
      return this.curStage === utils.SwapStage.SwapStageGetTokenList
    },

    checkIsGetDepositInfoStage () {
      return this.curStage === utils.SwapStage.SwapStageGetDepositInfo
    },

    getStagePanelClass () {
      if (this.checkIsGetTokenListStage()) {
        return 'panel-step1'
      } else if (this.checkIsGetDepositInfoStage()) {
        return 'panel-step2'
      }
      return 'panel-status'
    },

    getPanelTitle () {
      return this.checkIsGetTokenListStage() ? this.$t('message.panel_title_step1') : this.$t('message.panel_title_step2')
    },

    getPanelSubtitle () {
      return ''
    },

    getNextBtnTitle () {
      if (this.curStage !== utils.SwapStage.SwapStageGetTokenList) {
        return this.$t('message.start_over_btn')
      }
      return this.$t('message.next_btn')
    },

    backToStep1 () {
      this.curStage = utils.SwapStage.SwapStageGetTokenList
    },

    goToStatusPage () {
      this.$router.push('/records')
    },

    async onclickNextBtn () {
      if (!this.checkIsGetTokenListStage()) return

      let info = this.$refs.tokenListView.getSwapInfo()
      this.curSwapType = info.swapType
      this.swapAddress = info.address
      this.exChangeMemo = info.exChangeMemo

      if (this.swapAddress.length < 1) {
        utils.showAlert(this.$t('message.tips'), this.$t('message.enter_address_tips'))
        return
      }

      let isBnbExchange = utils.checkIsBnbExchangeAddr(this.swapAddress) && utils.checkIsSwapToBep2(this.curSwapType)
      let isCosExchange = utils.checkIsCosMainNetExchangeAddr(this.swapAddress) && utils.checkIsSwapToCosMainNet(this.curSwapType)
      if ((isBnbExchange || isCosExchange) && this.exChangeMemo.length < 1) {
        utils.showAlert(this.$t('message.tips'), this.$t('message.enter_exChange_memo_tips'))
        return
      }
      if (isBnbExchange && !utils.isValidBnbExchangeMemo(this.exChangeMemo)) {
        utils.showAlert(this.$t('message.tips'), this.$t('message.invalid_bnb_exChange_memo_tips'))
        return
      }
      if (this.isQuerying) return

      this.isQuerying = true
      this.mdLoadingDisplayState(true)
      let result = await webAPI.getDepositInfo(this.curSwapType, this.swapAddress, this.exChangeMemo)
      this.mdLoadingDisplayState(false)
      this.isQuerying = false

      if (utils.checkIsNotNullObj(result.res)) {
        this.depositInfo = result.res || {}
        this.depositInfo[utils.swapTypeKey] = this.curSwapType
        this.depositInfo[utils.swapAddressKey] = this.swapAddress
        this.depositInfo[utils.exChangeMemo] = this.exChangeMemo
        this.curStage = utils.SwapStage.SwapStageGetDepositInfo
      } else {
        utils.showAlert(this.$t('message.tips'), this.getErrorTipsByErrCode(result.errCode))
        console.log('Fail to fetch deposit info,the error code is %s, msg is %s', result.errCode, result.errMsg)
      }
    },

    async queryTokenList () {
      this.mdLoadingDisplayState(true)
      let result = await webAPI.getSwapTokenList()
      this.mdLoadingDisplayState(false)
      if (utils.checkIsNotNullObj(result.res)) {
        this.tokenList = result.res || []
      } else {
        utils.showAlert('Fail to get token list', result.errMsg)
        console.log('Fail to fetch swap token list,the error code is %s, msg is %s', result.errCode, result.errMsg)
      }
    },

    async checkServiceStatus () {
      this.mdLoadingDisplayState(true)
      let result = await webAPI.isServiceAvailable()
      this.mdLoadingDisplayState(false)
      if (utils.checkIsNotNullObj(result.res)) {
        this.serviceAvailable = result.res || false
      } else {
        utils.showAlert('Failed to get service status')
      }
    },

    mdLoadingDisplayState (isShow) {
      this.isShowLoading = isShow
    },

    getErrorTipsByErrCode (code) {
      const ERROR_CODE_KEYS = {
        [utils.netErrorCode.netErrorCodeSystemError]: 'message.swap_system_error',
        [utils.netErrorCode.netErrorCodeSwapAddressInvalid]: 'message.swap_address_invalid',
        [utils.netErrorCode.netErrorCodeSwapAddressNotExist]: 'message.swap_address_not_exit',
        [utils.netErrorCode.netErrorCodeInvalidSwapType]: 'message.swap_type_invalid',
        [utils.netErrorCode.netErrorCodeInvalidExchangeMemo]: 'message.swap_memo_invalid'
      }
      return this.$t(ERROR_CODE_KEYS[code] || 'message.swap_unknown_error')
    }
  },
  created () {
  },
  async mounted () {
    console.log('current env is', process.env.NODE_ENV)
    this.curLanguageType = this.getCurrentLanguageType()
    this.curLanguage = this.getCurrentLanguage()
    await this.checkServiceStatus()
    this.queryTokenList()
  }
}
</script>

<style scoped>
  .app_container {
    width: 100%;
    min-height: 100vh;
    font-family: "Poppins", "PingFang TC", "Noto Sans TC", sans-serif;
    background: #f9fafb;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .app_shell {
    width: 100%;
    max-width: 760px;
    margin: 0 auto;
    margin-top: 64px;
    margin-bottom: 64px;
    min-height: calc(100vh - 128px);
    padding: 16px 20px 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .desc_container {
    box-sizing: border-box;
    width: 100%;
    margin: 14px auto 18px;
    padding: 0;
    text-align: center;
    clear: both;
  }

  .top_header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 64px;
    padding: 0 32px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-bottom: 1px solid #e4e4e7;
    z-index: 100;
  }

  .header_logo_link {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
  }

  .header_logo {
    width: 135px;
    height: 43px;
    object-fit: contain;
    display: block;
  }

  .desc_text,
  .panel_subtitle {
    color: #70757f;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.4;
    text-align: center;
  }

  .desc_title,
  .panel_title {
    color: #0d0d0d;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: -0.5px;
    line-height: 1.2;
    text-align: center;
  }

  .desc_title {
    margin-bottom: 8px;
  }

  .language_bg {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    color: #374151;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }

  .language_bg .el-dropdown {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  .language_bg .el-dropdown:focus,
  .language_bg .el-dropdown:hover {
    outline: none;
    color: #6a11cb;
  }

  .language-arrow-down {
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #71717a;
    margin-left: 5px;
    margin-top: 1px;
    pointer-events: none;
  }

  .operate_container {
    width: 100%;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    padding: 0;
    box-sizing: border-box;
  }

  .panel-step1 .token_bg {
    max-width: 430px;
  }

  .panel-step2 .card_bg {
    max-width: 620px;
  }

  .panel-status .status_block {
    max-width: 960px;
  }

  .panel_header {
    width: 100%;
    text-align: center;
    margin-bottom: 32px;
  }

  .panel_subtitle {
    margin-top: 10px;
  }

  .out_of_service {
    width: 80%;
    max-width: 768px;
    margin: 60px auto;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }

  .service_mail {
    color: #80848d;
    text-decoration: none;
    font-size: 13px;
  }

  .footer_copyright {
    color: #80848d;
    font-size: 12px;
  }

  .action_row {
    width: 50%;
    max-width: none;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
  }

  .action_row > .next_btn,
  .action_row > .secondary_btn {
    width: 100%;
    max-width: none;
    margin-bottom: 0;
  }

  .next_btn {
    width: 100%;
    max-width: 430px;
    height: 48px;
    padding: 0;
    outline-style: none;
    border-style: none;
    background-image: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
    border-radius: 0;
    color: white;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.2px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: opacity 0.18s ease;
  }

  .next_btn:hover {
    opacity: 0.9;
  }

  .next_btn:active {
    opacity: 1;
  }

  .secondary_btn {
    width: 100%;
    max-width: 300px;
    height: 48px;
    padding: 0;
    outline-style: none;
    border: 1px solid #6a11cb;
    border-radius: 0;
    background: #fff;
    color: #6a11cb;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }

  .secondary_btn span {
    color: inherit;
  }

  .secondary_btn:hover {
    opacity: 0.7;
  }

  .secondary_btn:active {
    opacity: 1;
  }

  .el-footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    padding: 16px 40px !important;
    box-sizing: border-box;
    border-top: 1px solid #e4e4e7;
    background: #fff;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    line-height: 1;
    z-index: 100;
  }

  @media (max-width: 1024px) {
    .app_shell {
      padding-top: 16px;
      padding-bottom: 12px;
    }

    .top_header {
      padding: 0 32px;
    }

    .el-footer {
      padding: 16px 32px !important;
    }

    .desc_title {
      font-size: 28px;
    }

  }

  @media (max-width: 600px) {
    .app_shell {
      padding: 12px 12px 4px;
    }

    .top_header {
      padding: 0 12px;
    }

    .el-footer {
      padding: 16px 12px !important;
    }

    .action_row {
      width: 100%;
    }

    .next_btn {
      width: 100%;
      max-width: none;
    }

    .secondary_btn {
      max-width: none;
    }
  }
</style>
